import { NegotiationAgreementStatus, NegotiationStatus } from "../../../shared/services/api/sinister/AgreementRenegotiationService";
import { getAgreementStatusLabel } from "./agreementStatusOptions";

// Normaliza pra maiúsculo antes de comparar — o backend às vezes manda o valor em lowercase
// (mesmo padrão já visto no status "active"/"on_time" do acordo), o que fazia o badge cair
// no default e mostrar o valor cru em vez do rótulo traduzido.
const upper = (status: string): string => (status ?? "").toUpperCase();

export const getNegotiationStatusLabel = (status: NegotiationStatus | string): string => {
	switch (upper(status)) {
		case "OPEN":
			return "Aberta";
		case "CLOSED":
			return "Fechada";
		default:
			return status;
	}
};

export const getNegotiationStatusChipColors = (status: NegotiationStatus | string): { bg: string; color: string } => {
	switch (upper(status)) {
		case "OPEN":
			return { bg: "#e9f8f5", color: "#43b897" };
		case "CLOSED":
			return { bg: "#ECECEC", color: "#757575" };
		default:
			return { bg: "#ECECEC", color: "#757575" };
	}
};

// Vocabulário próprio do modelo de Negociação (PR-06) — não confundir com `AgreementStatus`
// (usado pelo restante do módulo Acordos), que tem valores diferentes
// (on_time/overdue/paid_off/broken/preventive/renegotiated).
export const getNegotiationAgreementStatusLabel = (status: NegotiationAgreementStatus | string): string => {
	switch (upper(status)) {
		case "ACTIVE":
			return "Em dia";
		case "RENEGOTIATED":
			return "Renegociado";
		case "CANCELED":
			return "Cancelado";
		case "FINISHED":
			return "Finalizado";
		default:
			// Fallback: o histórico de negociação (PR-06) às vezes recebe o vocabulário de status do
			// próprio acordo (on_time/overdue/paid_off/broken/preventive/renegotiated) em vez do
			// vocabulário próprio da negociação — tenta traduzir por ali antes de desistir e mostrar cru.
			return getAgreementStatusLabel(status);
	}
};

export const getNegotiationAgreementStatusChipColors = (status: NegotiationAgreementStatus | string): { bg: string; color: string } => {
	switch (upper(status)) {
		case "ACTIVE":
			return { bg: "#e9f8f5", color: "#43b897" };
		case "RENEGOTIATED":
			return { bg: "#fff9e0", color: "#c9a300" };
		case "CANCELED":
			return { bg: "#fcedea", color: "#e36b5b" };
		case "FINISHED":
			return { bg: "#e0faff", color: "#0f92d4" };
		default:
			return { bg: "#ECECEC", color: "#757575" };
	}
};
